module.exports = __webpack_public_path__ + "img/header-diamondJewelry070Carat.73c81fb.webp";